module.exports = __webpack_public_path__ + "img/青丘.533102f8.png";